import rc4 from './rc4'
import axios from 'axios';

const enableDecrypt = true; //process.env.NODE_ENV == 'production'
const enableDebug = false;

// 锁：记录当前正在pending的请求key，格式 action||json字符串
let pendingPostKey = null;
// 兜底超时，防止请求卡死锁不释放
const POST_LOCK_TIMEOUT = 5000;

export function proxyPost(action, data) {
  const str = JSON.stringify(data);
  const key = `${action}||${str}`;

  // 相同请求正在执行，拦截重复提交
  if (pendingPostKey === key) {
    console.log("[请勿重复提交]", action);
    return Promise.resolve({ code: 0, message: '请勿重复提交', data: null });
  }

  pendingPostKey = key;
  // 兜底定时器，超时强制解锁
  const timeoutTimer = setTimeout(() => {
    if (pendingPostKey === key) {
      pendingPostKey = null;
    }
  }, POST_LOCK_TIMEOUT);

  const wrapPromise = (async () => {
    try {
      if (enableDecrypt) {
        return await postdata_decrypt(action, data)
      } else {
        return await postdata_undecrypt(action, data)
      }
    } finally {
      // 无论成功失败，清除定时器、释放锁
      clearTimeout(timeoutTimer);
      if (pendingPostKey === key) {
        pendingPostKey = null;
      }
    }
  })();

  return wrapPromise;
}

export async function postdata_undecrypt(action, data) {
  const temp = { 'action': '', 'data': {} }
  temp.action = action
  temp.data = data || {}
  // await 等待axios请求完成并拿到返回结果
  const res = await axios.post('/api/proxy/postJson', temp)
  return res.data;
}

// 改为async await，移除手动new Promise包装
export async function postdata_decrypt(action, data) {
  const key = "wilson2025@sh";
  const pass = generateRandomString();
  const postinfo = { 'action': '', 'data': {} }
  postinfo.action = action
  postinfo.data = data || {}

  const poststr = JSON.stringify(postinfo);
  const newinfo = {};
  newinfo.pass = encodeString(pass, key);
  newinfo.data = encodeString(poststr, pass);

  if (enableDebug) {
    console.log("send", data)
  }
  const res = await axios.post(`/api/proxy/postJson`, newinfo);
  const rtdata = res.data.data;
  const newpass = decodeString(rtdata.key, key);
  const newdata = decodeString(rtdata.data, newpass);
  const newobj = JSON.parse(newdata);
  if (enableDebug) {
    console.log("res:", newobj)
  }
  return newobj;
}

// 生成10位随机密码
function generateRandomString(length = 10) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// 根据密码解码数据
function decodeString(str, pass) {
  const passarr = decodeBase64(str);
  let pass1 = rc4.crypt(pass, passarr, false)
  let newstr = uint8ArrayToString(pass1);
  return newstr;
}

// 根据密码加密数据
function encodeString(str, pass) {
  const ssstr = rc4.crypt(pass, str, false);
  const newstr = encodeBase64(ssstr);
  return newstr;
}

function uint8ArrayToString(uint8Array) {
  return new TextDecoder('utf-8').decode(uint8Array);
}

function uint8ArrayToBase64(uint8Array) {
  let binary = '';
  const len = uint8Array.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binary);
}

function encodeBase64(str) {
  return uint8ArrayToBase64(str)
}

function base64ToUint8Array(base64) {
  const binaryString = safeAtob(base64);
  const len = binaryString.length;
  const uint8Array = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }
  return uint8Array;
}

// Base64 解码
function decodeBase64(base64Str) {
  return base64ToUint8Array(base64Str)
}

/**
 * 安全Base64 / Base64URL 解码，兼容后端常用的base64url格式
 * @param {string} str base64 or base64url
 * @returns {string} binaryString
 */
function safeAtob(str) {
  try {
    // 关键：强制转为字符串，null/undefined变成"null"/"undefined"，后续捕获异常
    str = String(str ?? "");
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4 !== 0) {
      str += '=';
    }
    return atob(str);
  } catch (e) {
    console.error('base64解码失败，原始值：', str, e);
    return '';
  }
}

